<template>
    <main-layout>
        <template #breadcrumbs>
            <span class="union-icon">
                <i class="feather-tag"></i>
            </span>
            <span class="repo-chart-title">
                <inertia-link :href="route('home')">
                    <span class="repo-text">Repositories</span>
                </inertia-link>
                <span class="d-line">/ </span>
                <inertia-link :href="route('repository.view', {team: team})">
                    <span class="repo-text">{{ team.name }}</span>
                </inertia-link>
                <span class="d-line">/ </span>
                Add new chart
            </span>
        </template>
        <template #pageTitle>
            <h2 class="mb-1">{{team.slug}}</h2>
            <span class="sm-text">This page contains list of helm charts for '{{ team.slug }}' repository</span>
        </template>

        <push-instructions :slug="team.slug" :username="username" />

        <template #rightSidebar>
            <repository-sidebar :slug="team.slug" :show-repo-add="false" :username="username" />
        </template>
    </main-layout>
</template>

<script>
    import MainLayout from "@/Layouts/MainLayout";
    import PushInstructions from "@/Pages/Repository/PushInstructions";
    import RepositorySidebar from "@/Pages/Repository/RepositorySidebar";
    export default {
        name: "AddHelmChart",
        components: {RepositorySidebar, PushInstructions, MainLayout},
        props: ['team', 'username' ]
    }
</script>

<style scoped>

</style>
